import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantResidenceTypePage = {
  alert: {
    error: 'applicant-residence-type-page.form.alert.error',
  },
  footer: {
    root: 'applicant-residence-type-page.footer.root',
  },
  form: {
    h1: 'applicant-residence-type-page.form.h1',
    h2: 'applicant-residence-type-page.form.h2',
    radioGroupRoot: 'applicant-residence-type-page.form.radio-group-root',
    radioOption1: 'applicant-residence-type-page.form.radio-option-1',
    radioOption2: 'applicant-residence-type-page.form.radio-option-2',
    radioOption3: 'applicant-residence-type-page.form.radio-option-3',
    root: 'applicant-residence-type-page.form.root',
    submitButton: 'applicant-residence-type-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
